<div id="balanceSheetElement" #balanceSheetElement>
	<div class="d-flex">
		<div class="display-10 ms-1 mt-2 mb-1">
			Gift Card Balance Sheet
			<div class="display-14 ms-4">
				{{ venueService.subscriptionVenue.value.name }}
			</div>
		</div>
		<div class="ms-auto d-flex">
			<div class="my-auto">
				<p-calendar [(ngModel)]="endDate" (ngModelChange)="getBalanceSheet(endDate)"></p-calendar>
			</div>

			<fa-icon
				[icon]="['far', 'file-pdf']"
				size="2x"
				(click)="app.generatePdfForDownload('balanceSheetElement', 'balanceSheet-' + endDate)"
				class="ms-2 my-auto"
			></fa-icon>
		</div>
	</div>
	<p-divider></p-divider>
	<div class="d-flex w-100">
		<div>
			As of <span *ngIf="balanceSheet"> {{ endDate | date: 'mediumDate' }}</span>
		</div>
		<div class="ms-auto">
			<div class="d-flex">
				<div class="my-auto me-2">Store Detail</div>
				<div class="my-auto"><p-inputSwitch label="Store Detail" [(ngModel)]="storeDetail"></p-inputSwitch></div>
			</div>
		</div>
	</div>
	<p-divider>Income</p-divider>
	<div class="p-grid">
		<div class="p-col-6 display-14">Activations</div>
		<div class="p-col-6 display-14">
			<p-skeleton *ngIf="!balanceSheet"></p-skeleton>
			<span *ngIf="balanceSheet">{{ balanceSheet.activations | currency }}</span>
			<ng-container *ngIf="storeDetail && balanceSheet">
				<ng-container *ngFor="let store of balanceSheet.activityByStore">
					<div class="ms-4 p-grid">
						<div class="p-col-3">
							{{ store.venueName }}
						</div>
						<div class="p-col-9">
							{{ store.activations | currency }}
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-6 display-14">Reloads</div>
		<div class="p-col-6 display-14">
			<p-skeleton *ngIf="!balanceSheet"></p-skeleton>
			<span *ngIf="balanceSheet">{{ balanceSheet.increments | currency }}</span>
			<ng-container *ngIf="storeDetail && balanceSheet">
				<ng-container *ngFor="let store of balanceSheet.activityByStore">
					<div class="ms-4 p-grid">
						<div class="p-col-3">
							{{ store.venueName }}
						</div>
						<div class="p-col-9">
							{{ store.increments | currency }}
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-6 display-14 p-text-bold">Total Income</div>
		<div class="p-col-6 display-14 p-text-bold">
			<p-skeleton *ngIf="!balanceSheet"></p-skeleton>
			<span *ngIf="balanceSheet">{{ balanceSheet.activations + balanceSheet.increments | currency }}</span>
			<ng-container *ngIf="storeDetail && balanceSheet">
				<ng-container *ngFor="let store of balanceSheet.activityByStore">
					<div class="ms-4 p-grid">
						<div class="p-col-3">
							{{ store.venueName }}
						</div>
						<div class="p-col-9">
							{{ store.activations + store.increments | currency }}
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
	<p-divider>Redemption</p-divider>
	<div class="p-grid">
		<div class="p-col-6 display-14">Redemptions</div>
		<div class="p-col-6 display-14">
			<p-skeleton *ngIf="!balanceSheet"></p-skeleton>
			<span *ngIf="balanceSheet">{{ balanceSheet.redemptions | currency }}</span>
			<ng-container *ngIf="storeDetail && balanceSheet">
				<ng-container *ngFor="let store of balanceSheet.activityByStore">
					<div class="ms-4 p-grid">
						<div class="p-col-3">
							{{ store.venueName }}
						</div>
						<div class="p-col-9">
							{{ store.redemptions | currency }}
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-6 display-14">Adjustments</div>
		<div class="p-col-6 display-14">
			<p-skeleton *ngIf="!balanceSheet"></p-skeleton>
			<span *ngIf="balanceSheet">{{ balanceSheet.adjustments | currency }}</span>
			<ng-container *ngIf="storeDetail && balanceSheet">
				<ng-container *ngFor="let store of balanceSheet.activityByStore">
					<div class="ms-4 p-grid">
						<div class="p-col-3">
							{{ store.venueName }}
						</div>
						<div class="p-col-9">
							{{ store.adjustments | currency }}
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-6 display-14 p-text-bold">Total Redemption</div>
		<div class="p-col-6 display-14 p-text-bold">
			<p-skeleton *ngIf="!balanceSheet"></p-skeleton>
			<span *ngIf="balanceSheet">{{ balanceSheet.redemptions + balanceSheet.adjustments | currency }}</span>
			<ng-container *ngIf="storeDetail && balanceSheet">
				<ng-container *ngFor="let store of balanceSheet.activityByStore">
					<div class="ms-4 p-grid">
						<div class="p-col-3">
							{{ store.venueName }}
						</div>
						<div class="p-col-9">
							{{ store.redemptions + store.adjustments | currency }}
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
	<p-divider></p-divider>
	<div class="p-grid">
		<div class="p-col-6 display-14 p-text-bold">Balance</div>
		<div class="p-col-6 display-14 p-text-bold">
			<p-skeleton *ngIf="!balanceSheet"></p-skeleton>
			<span *ngIf="balanceSheet">{{ balanceSheet.balance | currency }}</span>
			<ng-container *ngIf="storeDetail && balanceSheet">
				<ng-container *ngFor="let store of balanceSheet.activityByStore">
					<div class="ms-4 p-grid">
						<div class="p-col-3">
							{{ store.venueName }}
						</div>
						<div class="p-col-9">
							{{ store.balance | currency }}
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
</div>
